import Login from '@/pages/Login'
import PhoneLogin from '@/pages/ServiceLogin'

export default [
  {
    path: '/',
    redirect: '/login',
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    meta: {
      title: '登入',
    },
  },
  {
    path: '/servicelogin',
    name: 'ServiceLogin',
    component: PhoneLogin,
    meta: {
      title: '登入',
    },
  },
]



// WEBPACK FOOTER //
// ./src/router/loginRouterTable.js